import { ApolloQueryResult } from '@apollo/client/core';
import { Injectable, inject } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable, Subject } from "rxjs";
import { GET_LAST_ANNOUNCEMENT, GET_SPACE_ANNOUNCEMENT_BY_ID } from "@riise/graphql/announcements/announcements.queries";


@Injectable({
    providedIn: 'root',
})


export class AnnouncementsService {

    private apollo = inject(Apollo);

    getLastAnnouncement() {
        return this.apollo.watchQuery<any>({
            query: GET_LAST_ANNOUNCEMENT,
            fetchPolicy: 'no-cache', // or 'network-only'
        }).valueChanges;
    }

    getAnnouncementId(id: string) {
        return this.apollo.watchQuery<any>({
            query: GET_SPACE_ANNOUNCEMENT_BY_ID,
            fetchPolicy: 'no-cache', // or 'network-only'
            variables: {
                id: id,
            },
        }).valueChanges;
    }


}

